import { http } from "./http";

const ENDPOINTS = {
  NOTIFICATIONS: "/notification/",
  NOTIFICATION: (id) => `/notification/${id}/`,
  NOTIFICATION_MARK_READ: (id) => `/notification/${id}/mark_as_read/`,
  NOTIFICATION_REJECT_INVOICE: (id) => `/notification/${id}/reject_invoice/`,
  NOTIFICATION_APPROVE_INVOICE: (id) => `/notification/${id}/approve_invoice/`,
  NOTIFICATION_MARK_ALL_READ: "/notification/mark_all_as_read/",
};

export const notificationAPI = {
  getAll: () => http.get(ENDPOINTS.NOTIFICATIONS),
  getById: (id) => http.get(ENDPOINTS.NOTIFICATION(id)),
  mark_as_read: (id) => http.post(ENDPOINTS.NOTIFICATION_MARK_READ(id)),
  approve_invoice: (id) => http.post(ENDPOINTS.NOTIFICATION_APPROVE_INVOICE(id)),
  reject_invoice: (id) => http.post(ENDPOINTS.NOTIFICATION_REJECT_INVOICE(id)),
  markAllAsRead: () => http.post(ENDPOINTS.NOTIFICATION_MARK_ALL_READ)
};